import Environment from "../Helper/APIParam.js";
import { APPCONSTANT } from "./AppConstant.js";

var AppName = "Traldy SDK";
export default AppName;

//User module paths
export var DEV = "https://api.dev.tradly.app";
export var PRO = "https://api.tradly.app";
export var SANDBOX = "https://api.sandbox.tradly.app";
// export var BASEURL = Environment(APPCONSTANT.ENVIRONMENT);
export const REFRESH = "/v1/users/token/refresh";
export const TENANTS = "/v1/tenants/";
export const CONFIG = "/configs";
export const CONFIGLIST = "/v1/configs?key_group=";
export const GROUPCONFIGLIST = "/v1/configs/list_grouped?key_group=";

export const LOGIN = "/v1/users/login";
export const SOCIAL_LOGIN = "/v1/users/social_login";
export const REGISTER = "/v1/users/register";
export const VERIFY = "/v1/users/verify";
export const FORGOTPASSWORD = "/v1/users/password/recovery";
export const SETPASSWORD = "/v1/users/password/set";

export const USERS = "/v1/users";
export const DEVICES = "/v1/devices";

export const ADDRESS = "/v1/addresses";
export const STATES = "/v1/states";
export const SEARCHADDRESS = "/v1/addresses/search?key=";
export const PLACES_ADDRESS = "/v1/addresses/places_search";
export const PLACES_ADDRESS_DETAIL = "/v1/addresses/place_detail";
export const CURRENCY = "/v1/currencies";
export const LANGUAGES = "/v1/languages";
export const TENANTLANGUAGES = "/v1/tenants/languages";
export const COUNTRIES = "/v1/countries";
export const TENANTSCOUNTRIES = "/v1/tenants/countries";

export const CATEGORY = "/v1/categories";
export const ATTRIBUTE = "/v1/attributes";
export const VALUES = "/values";

export const ACCOUNTS = "/v1/accounts";
export const ACCOUNTSUNIQUELOCATIONS = "/v1/accounts/unique/locations";
export const FOLLOW = "/follow";
export const BLOCK = "/block";
export const REPORT = "/report";

export const SSO_ENABLED = "/v1/users/sso";
export const SSO_RETURN = "/v1/users/sso_return";

export const LISTINGS = "/products/v1/listings";
export const LISTINGSUNIQUELOCATIONS = "/products/v1/listings/unique/locations";
export const LIKE = "/likes";
export const UNLIKE = "/unlikes";
export const SCHEDULE = "/schedules";
export const SCHEDULEPERDAY = "/schedules_per_day?";
export const SLUG = "/by_slug/";
export const NEGOTIATE = "/negotiations";

export const VARIANTTYPES = "/products/v1/variant_types";
export const VARIANTS = "/variants";

export const PAYMENTSMETHODS = "/v1/tenants/payment_methods";
export const TENANTSHIPPINGMETHOD = "/v1/tenants/shipping_methods";
export const SHIPPINGMETHOD = "/v1/shipping_methods";
export const SHIPMENTS = "/v1/shipments/";

export const S3SIGNEDURL = "/v1/utils/S3signedUploadURL";
export const S3SIGNEDGETURL = "/v1/utils/S3signedGetURL";

export const HOME = "/products/v1/home";
export const ORDERS = "/products/v1/orders";

export const CART = "/products/v1/cart";
export const CHECKOUT = "/checkout";
export const EPHERMERALKEY = "/v1/payments/stripe/ephemeralKey";
export const PAYMENTINTENT = "/v1/payments/stripe/paymentIntent";
export const COUPON = "/products/v1/cart/coupon";

export const STRIPECONNECTACCOUNT =
	"/v1/payments/stripe/connect/account?account_id=";
export const CREATEACCOUNTLINK = "/v1/payments/stripe/connect/account_links";
export const CREATEEXPRESSLOGINLINK = "/v1/payments/stripe/connect/login_links";

export const STATUS = "/status";
export const REVIEW = "/v1/reviews";

export const COLLECTIONS = "/v1/collections";
export const COLLECTIONS_DATA = "/v1/collections_data";
export const PROMO = "/v1/promos";
export const TRANSACTIONS = "/v1/transactions";
export const EARNINGS = "/v1/earnings";

export const BLOCKEDACCOUNT = "/v1/accounts/feeds/blocked?type=accounts&";
export const FOLLOWINGACCOUNT = "/v1/accounts/feeds/following?type=accounts&";

export const FOLLOWINGLISTING = "/products/v1/feeds/following?type=listings&";

export const LAYER = "/v1/layers";

export const TAX = "/v1/taxes";

export const TRANSLATIONS = "/v1/translations";

export const CLIENTTRANSLATION_GROUPS = "/v1/client_translations/groups";
export const CLIENTTRANSLATION_VALUES = "/v1/client_translations/values";
export const CLIENTTRANSLATION_VALUES_GROUP =
	"/v1/client_translations/values_grouped";

export const CREATE_FEEDBACK = "/v1/utils/feedback";
export const FEEDBACK_CATEGORIES = "/v1/utils/feedback_categories";

export const GET_COMMENTS = "/v1/comments";
export const CREATE_COMMENTS = "/v1/comments";

export const ACTIVITIES = "/v1/activities";

export const COMMISSIONS = "/v1/commissions";

export const LOGOUT = "/v1/users/logout";

export const SUBSCRIPTION = "/v1/subscriptions/subscribe";
export const SUBSCRIPTION_LISTINGS = "/v1/subscription_products";
export const SUBSCRIPTION_CONFIRM = "/v1/subscriptions/subscribe/confirm";
export const SUBSCRIPTION_MANAGE = "/v1/subscriptions/manage";
export const SUBSCRIPTION_EMAIL_TRIGGER = "/v1/subscriptions/email_trigger";

export const MANGO_PAY = "/v1/payments/mangopay";
export const SAVED_CARD = "/v1/saved_cards";

export const OPP_MERCHANT = "/v1/payments/opp/merchant";

export const TIME_SLOT = "v1/timeslots";

export const DIGITAL_CONTENT = "/digital_contents";

export const WALLET = "/v1/wallet";

export const AI_SERVICES = "/v1/ai_services";
